export const columns = [
    {
        Header: 'Serial Number',
        accessor: 'SerialNumber',
        component: (warranty) => (
            <ClickableLink
                href={warranty?.DeviceLink}
                text={warranty?.SerialNumber}
            />
        ),
    },
    {
        Header: 'Device Name',
        accessor: 'DeviceName',
        component: (warranty) => (
            <ClickableLink
                href={warranty?.DeviceLink}
                text={warranty?.DeviceName}
            />
        ),
    },
    {
        Header: 'Address',
        accessor: 'Address',
        component: (warranty) => (
            <ClickableLink href={warranty?.SiteLink} text={warranty?.Address} />
        ),
    },
    {
        Header: 'Warranty Start',
        accessor: 'WarrantyStart',
    },
    {
        Header: 'Warranty Exp',
        accessor: 'WarrantyEnd',
    },
    {
        Header: 'Customer Name',
        accessor: 'CustomerName',
    },
    {
        Header: 'Customer Email',
        accessor: 'CustomerEmail',
    },
    {
        Header: 'Customer Phone',
        accessor: 'CustomerPhone',
        component: (warranty) => (
            <span>{warranty.CustomerPhone?.replace('+', '')}</span>
        ),
    },
    {
        Header: 'Installer',
        accessor: 'InstallerName',
    },
    {
        Header: 'Installer Email',
        accessor: 'InstallerEmail',
    },
];

const ClickableLink = ({ href, text }) => {
    const displayText = text ?? href;
    
    if (!href) {
        return <span tabIndex={-1} role="link" aria-disabled="true">{displayText}</span>;
    }
    
    return (
        <a href={`/${href}`} className="hover:text-accent hover:underline">
            {displayText}
        </a>
    );
};
